export const NewsConstant = {
  NEWS_CATEGORY: {
    GENERAL_NEWS: "general_news",
    FEATURED_NEWS: "featured_news",
    ADVERTISEMENT: "advertisement"
  }
}